export default function ContactForm() {
    const handleSubmit = (event) => {
        event.preventDefault();

        const myForm = event.target;
        const formData = new FormData(myForm);

        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString(),
        })
            .then(() => alert("Merci de votre message ! Nous vous répondrons dans les plus brefs délais."))
            .catch((error) => alert(error));
    };

    document
        .querySelector("form")
        .addEventListener("submit", handleSubmit);


    return (
        <>
            <section>
                <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center">Nous contacter</h2>
                    <p className="mb-8 lg:mb-16 font-light text-center">Vous avez un problème technique ? Vous souhaitez nous faire part de vos commentaires sur notre site ? N'hésitez pas à nous contacter.</p>
                    <form method="post" className="space-y-8" data-netlify="true" name="contact" onSubmit={handleSubmit}>
                        <input type="hidden" name="form-name" value="contact"/>
                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium">Email</label>
                            <input type="email" name="email" id="email" className="input-text shadow-sm border border-gray-300 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5" placeholder="exemple@suplib.com" required/>
                        </div>
                        <div>
                            <label htmlFor="subject" className="block mb-2 text-sm font-medium">Sujet</label>
                            <input type="text" name="subject" id="subject" className="input-text block p-3 w-full text-sm rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500" placeholder="En quoi pouvons-nous vous aider ?" required/>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="message" className="block mb-2 text-sm font-medium">Message</label>
                            <textarea id="message" name="message" rows="6" className="input-text block p-2.5 w-full text-sm rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500" placeholder="Laisser un commentaire..."></textarea>
                        </div>
                        <button type="submit" className="flex mx-auto py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-blue-900 sm:w-fit hover:bg-black focus:ring-4 focus:outline-none focus:ring-primary-300">Envoyer</button>
                    </form>
                </div>
            </section>
        </>
    );
}